// @flow
import React from 'react';
import PropTypes from 'prop-types';

type Props = {|
  loading: boolean,
  mask: boolean,
  size: 'small' | 'medium',
|};

export default function LegacyLoadingSpinner({ mask, loading, size }: Props) {
  return (
    <div>
      {mask && (
        <div
          className="moduleMask"
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            top: 0,
          }}
        />
      )}
      {loading && (
        <div className="Spinner">
          <div className={size === 'small' ? 'spinnerSmall' : 'spinnerMedium'} />
        </div>
      )}
    </div>
  );
}

LegacyLoadingSpinner.propTypes = {
  loading: PropTypes.bool,
  mask: PropTypes.bool,
  size: PropTypes.string,
};

LegacyLoadingSpinner.defaultProps = {
  loading: true,
  mask: true,
  size: 'medium',
};
